import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { httpService } from '../../../services/http.service';
import { IServerErrorResponse } from '../../../types';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';
import { trackMixPanel } from '../../../services/mixpanel.service';
import { IWireFees } from './getWireFees';
import { endpointManager } from '../../../services/endpoint.service';

export const getMailFees = () => {
  const { getMailCheckFeesUrl } = endpointManager();
  return useQuery(
    'getMailFees',
    async (): Promise<IWireFees> => {
      const res = await httpService.get(getMailCheckFeesUrl());
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      enabled: false,
      retry: 1,
      onError: (e:IServerErrorResponse) => {
        const { localizedMessage, message, code } = flattenServerErrorResponse(e);
        trackMixPanel('Error Occurred During Move Money Flow', {
          'Error Code': code, 'Error Message': localizedMessage, 'Screen Name': 'Intro', Flow: 'Mail a Check',
        });
        toast.error(localizedMessage || message || 'Please try again.', {
          position: 'bottom-center',
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
        });
      },
    },
  );
};
